export class AwsEbsVolumeRestoreResult {
    'volumeId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "volumeId",
            "baseName": "volumeId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsEbsVolumeRestoreResult.attributeTypeMap;
    }
    constructor() {
    }
}
